import { Component, OnInit } from '@angular/core';
import { EmbryoService } from 'src/app/Services/Embryo.service';

@Component({
  selector: 'embryo-CTASingleBanner',
  templateUrl: './CTA-SingleBanner.component.html',
  styleUrls: ['./CTA-SingleBanner.component.scss'],
})
export class CTASingleBannerComponent implements OnInit {
  lang: any;
  constructor(public embryoService: EmbryoService) {
    this.embryoService.emitLang.subscribe((lang: any) => {
      this.lang = lang;
    });
  }

  ngOnInit() {}
}
